export const home = "timer";
